import React, { useEffect, useRef, useState } from 'react';
import { ArrowRight, CaretDown, Eye } from '@phosphor-icons/react';
import ENV from 'env';
import styles from './StagingBanner.module.css';

const HEIGHT_VAR = '--env-banner-height';
const DETAILS_ID = 'staging-banner-details';

const StagingBanner = () => {
    const ref = useRef<HTMLDivElement>(null);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const banner = ref.current;
        if (!banner) return;
        const observer = new ResizeObserver(() => {
            document.documentElement.style.setProperty(HEIGHT_VAR, `${banner.offsetHeight}px`);
        });
        observer.observe(banner);
        return () => {
            observer.disconnect();
            document.documentElement.style.removeProperty(HEIGHT_VAR);
        };
    }, []);

    if (!ENV.IS_STAGING) return null;

    const label = (
        <>
            <Eye size={16} weight="fill" />
            Staging mode
        </>
    );

    return (
        <div ref={ref} className={styles.wrapper}>
            <section aria-label="Staging mode" className={styles.banner}>
                <span className={`${styles.label} ${styles.desktopLabel}`}>{label}</span>
                <button
                    type="button"
                    className={styles.toggle}
                    aria-expanded={expanded}
                    aria-controls={DETAILS_ID}
                    onClick={() => setExpanded(!expanded)}
                >
                    <span className={styles.label}>{label}</span>
                    <CaretDown size={16} className={styles.caret} />
                </button>
                <div id={DETAILS_ID} className={`${styles.details} ${expanded ? styles.expanded : ''}`}>
                    <p className={styles.message}>
                        You&apos;re in the Staging environment. All changes are for testing purposes only and won&apos;t
                        affect real-world operations.
                    </p>
                    <a className={styles.link} href={ENV.PRODUCTION_URL}>
                        Go to Production
                        <ArrowRight size={16} />
                    </a>
                </div>
            </section>
        </div>
    );
};

export default StagingBanner;
